<template>
  <v-snackbar
    class="hidden-print-only"
    bottom
    right
    :color="color"
    v-model="visible"
    :timeout="timeout"
  >
    {{message}}
    <v-btn flat dark @click="hide">close</v-btn>
  </v-snackbar>
</template>

<script>
import modal from "./";
export default {
  data() {
    return {
      visible: false,
      message: "",
      color: "success",
      timeout: 5000
    };
  },
  methods: {
    hide() {
      this.visible = false;
    },
    show(params) {
      if (typeof params === "object") {
        this.message = params.message;
        this.color = params.color;
      } else this.message = params;

      this.visible = true;
    }
  },
  beforeMount() {
    modal.EventBus.$on("show", params => {
      this.show(params);
    });

    modal.EventBus.$on("success", message => {
      this.show({ message: message, color: "success" });
    });

    modal.EventBus.$on("error", message => {
      this.show({ message: message, color: "error" });
    });

    modal.EventBus.$on("hide", () => {
      this.hide();
    });
  }
};
</script>

<style scoped>
</style>